// ========================================
// מסך התחברות - LoginScreen
// ========================================
import React, { useState } from 'react';
import { Lock, Mail, LogIn, AlertCircle, Loader2 } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const LoginScreen = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [localError, setLocalError] = useState('');
    const { login, isLoading, error: authError } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLocalError('');

        // ולידציה בסיסית
        if (!email || !password) {
            setLocalError('נא למלא את כל השדות');
            return;
        }

        const result = await login(email, password);
        if (!result.success) {
            setLocalError(result.error);
        }
    };

    const displayError = localError || authError;

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
            {/* רקע דקורטיבי */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-aeg-red/20 rounded-full blur-3xl" />
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
            </div>

            {/* כרטיס התחברות */}
            <div className="relative w-full max-w-md" dir="rtl">
                {/* לוגו */}
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl shadow-2xl shadow-white/10 mb-4">
                        <span className="text-3xl font-black text-slate-900">A</span>
                    </div>
                    <h1 className="text-2xl font-bold text-white">AEG Stock Manager</h1>
                    <p className="text-slate-400 text-sm mt-1">מערכת ניהול מלאי חכמה</p>
                </div>

                {/* טופס */}
                <div className="glass-panel p-8 rounded-3xl">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* שדה אימייל */}
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-slate-300">אימייל</label>
                            <div className="relative">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="your@email.com"
                                    className="w-full h-14 bg-slate-800/50 border border-slate-700 rounded-xl px-4 pr-12 text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-aeg-red/50 focus:border-aeg-red transition-all"
                                    dir="ltr"
                                />
                                <Mail className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500" size={20} />
                            </div>
                        </div>

                        {/* שדה סיסמה */}
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-slate-300">סיסמה</label>
                            <div className="relative">
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    className="w-full h-14 bg-slate-800/50 border border-slate-700 rounded-xl px-4 pr-12 text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-aeg-red/50 focus:border-aeg-red transition-all"
                                    dir="ltr"
                                />
                                <Lock className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500" size={20} />
                            </div>
                        </div>

                        {/* הודעת שגיאה */}
                        {displayError && (
                            <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/20 rounded-xl text-red-400 text-sm">
                                <AlertCircle size={18} />
                                <span>{displayError}</span>
                            </div>
                        )}

                        {/* כפתור כניסה */}
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full h-14 bg-aeg-red hover:bg-aeg-red/90 disabled:bg-slate-700 text-white font-bold rounded-xl shadow-lg shadow-aeg-red/20 flex items-center justify-center gap-2 transition-all active:scale-[0.98]"
                        >
                            {isLoading ? (
                                <Loader2 className="animate-spin" size={20} />
                            ) : (
                                <>
                                    <LogIn size={20} />
                                    <span>כניסה למערכת</span>
                                </>
                            )}
                        </button>
                    </form>
                </div>

                {/* תחתית */}
                <p className="text-center text-slate-500 text-xs mt-6">
                    גרסה 2.0 | מופעל על ידי Supabase
                </p>
            </div>
        </div>
    );
};

export default LoginScreen;
